import { UserRound, Eye, Compass, Lock } from "lucide-react";
import { VALUES } from "@/data/services";
import { SectionHead, Reveal } from "@/components/ui/motion";

const ICONS = [UserRound, Eye, Compass, Lock];

export const WhySection = () => (
  <section className="bg-white pb-20 sm:pb-28 lg:pb-36" data-testid="why-section">
    <div className="wrap">
      <SectionHead eyebrow="Mengapa Kami" title={<>Mengapa Memilih <span className="serif-it font-normal text-accentb">Mika Solution?</span></>} />
      <div className="mt-14 grid grid-cols-1 gap-5 lg:mt-20 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <figure className="relative h-full min-h-[340px] overflow-hidden rounded-[1.5rem]">
            <img src="/images/table.jpg" alt="Diskusi tim pendamping bersama klien di meja kerja" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#263746]/80 via-[#263746]/10 to-transparent" />
            <figcaption className="absolute inset-x-0 bottom-0 p-7 sm:p-9">
              <p className="font-display text-2xl font-bold leading-tight text-white sm:text-3xl">Didengarkan dulu, <span className="serif-it font-normal text-sky-brand">baru</span> dijelaskan.</p>
            </figcaption>
          </figure>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-7">
          {VALUES.map((v, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={v.title} delay={i * 0.07}>
                <article className="card group h-full p-7 transition-colors duration-500 hover:border-sky-brand sm:p-8" data-testid={`value-card-${i}`}>
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-ice text-accentb transition-[background-color,color,transform] duration-500 group-hover:rotate-[-6deg] group-hover:bg-sky-brand group-hover:text-ink">
                    <Icon size={20} />
                  </span>
                  <h3 className="mt-8 font-display text-xl font-bold">{v.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-ink">{v.text}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
